module.exports = __webpack_public_path__ + "static/media/shape1_2.e799a297.obj";